import React from 'react';
import propTypes from 'prop-types';
import classnames from 'classnames';

import { addSection, trash as deleteSection } from 'ui/Icons';

import IconButton from './IconButton';
import defaultTheme from './SectionHeader.css';

/**
 * renders a section header
 * @param {object} props - compnent
 * @returns {Node} rendered section header
 */
const SectionHeader = ({
  children,
  'data-test-id': testId,
  isDelete,
  isReadonly,
  level,
  sectionToggle,
  theme: propTheme,
  onClick,
  ...restProps
}) => {
  const theme = {
    ...defaultTheme,
    ...propTheme
  };
  const wrapperStyle = classnames(
    'd-flex',
    'p-4',
    'w-100',
    theme.header,
    theme[`level${level}`]
  );
  const btnStyle = classnames(
    'd-flex',
    'align-items-center',
    'flex-grow-1',
    'border-0',
    'p-0',
    { [theme.pointer]: !!onClick }
  );

  return (
    <div className={wrapperStyle}>
      <button
        className={btnStyle}
        type="button"
        onClick={onClick}
        data-test-id={testId}
        {...restProps}
      >
        {children}
      </button>
      {sectionToggle && (
        <IconButton
          className={theme.sectionToggle}
          alt={`${isDelete ? 'delete' : 'add'} section`}
          icon={isDelete ? deleteSection : addSection}
          isReadonly={isReadonly}
          rem={1.5}
          onClick={sectionToggle}
          data-test-id={`${testId}-icon-button`}
        />
      )}
    </div>
  );
};

SectionHeader.propTypes = {
  children: propTypes.node,
  'data-test-id': propTypes.string,
  isDelete: propTypes.bool,
  isReadonly: propTypes.bool,
  level: propTypes.number,
  sectionToggle: propTypes.func,
  theme: propTypes.shape(),
  onClick: propTypes.func
};

SectionHeader.defaultProps = {
  children: null,
  'data-test-id': '',
  isDelete: false,
  isReadonly: false,
  level: 0,
  sectionToggle: null,
  theme: {},
  onClick: null
};

export default SectionHeader;
